import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import HeaderPrimary from 'flarum/forum/components/HeaderPrimary';
import HeaderSecondary from 'flarum/forum/components/HeaderSecondary';
import Navigation from 'flarum/common/components/Navigation';
import Button from 'flarum/common/components/Button';
import LinkButton from 'flarum/common/components/LinkButton';
import Link from 'flarum/common/components/Link';
import DiscussionComposer from 'flarum/forum/components/DiscussionComposer';
import LogInModal from 'flarum/forum/components/LogInModal';
import Search from 'flarum/forum/components/Search';
import GroupsSearchSource from './components/GroupsSearchSource';

// 全局操作提示弹窗 2 秒后自动关闭
app.initializers.add('tf-alerts-auto-dismiss', () => {
  const originalShow = app.alerts.show.bind(app.alerts);
  app.alerts.show = function (...args) {
    const id = originalShow.apply(app.alerts, args);
    setTimeout(() => {
      app.alerts.dismiss(id);
    }, 2000);
    return id;
  };
});

app.initializers.add('tf-custom-header', () => {
  try {
    // 获取基础路径的辅助函数
    const getBasePath = () => {
    let basePath = '';
    
    // 方法1: 从 Flarum 配置获取
    const baseUrl = app.forum.attribute('baseUrl') || '';
    if (baseUrl) {
      try {
        basePath = new URL(baseUrl).pathname;
      } catch (e) {
        // 如果 baseUrl 不是完整 URL，直接使用
        basePath = baseUrl.startsWith('/') ? baseUrl : '/' + baseUrl;
      }
    }
    
    // 方法2: 从 window.location 提取基础路径
    if (!basePath && typeof window !== 'undefined') {
      const fullPath = window.location.pathname;
      // 查找 /public 或基础路径
      const publicIndex = fullPath.indexOf('/public');
      if (publicIndex >= 0) {
        basePath = fullPath.substring(0, publicIndex + 7); // 包含 /public
      } else {
        // 如果没有 /public，尝试从路径中提取基础路径
        // 例如: /community_backup/public/ 的基础路径是 /community_backup/public
        const pathParts = fullPath.split('/').filter(p => p);
        if (pathParts.length > 1) {
          basePath = '/' + pathParts.slice(0, -1).join('/');
        }
      }
    }
    
    return basePath;
  };
  
  // 规范化href路径（用于href属性，包含基础路径）
  const normalizeHrefPath = (path) => {
    if (!path || path === '#' || path === '') {
      path = '/';
    }
    
    // 如果是完整 URL（http:// 或 https://），直接返回
    if (path.startsWith('http://') || path.startsWith('https://')) {
      return path;
    }
    
    // 移除 # 前缀（如果存在）
    let routePath = path;
    if (routePath.startsWith('#')) {
      routePath = routePath.substring(1);
    }
    
    // 确保路径以 / 开头
    if (!routePath.startsWith('/')) {
      routePath = '/' + routePath;
    }
    
    // 获取基础路径并添加到路由路径（用于href属性）
    const basePath = getBasePath();
    if (basePath && basePath !== '/') {
      // 确保 basePath 不以 / 结尾
      const normalizedBasePath = basePath.endsWith('/') ? basePath.slice(0, -1) : basePath;
      // 组合基础路径和路由路径
      return normalizedBasePath + routePath;
    }
    
    return routePath;
  };
  
  // 在Header-controls中添加导航项（从后台配置读取）
  extend(HeaderPrimary.prototype, 'items', function (items) {
    try {
      // 从设置中读取导航配置（JSON格式）
      const navItemsConfig = app.forum.attribute('tf-custom-header.nav-items');
      if (navItemsConfig) {
        let navItems = [];
        
        // 尝试解析JSON配置
        try {
          navItems = typeof navItemsConfig === 'string' 
            ? JSON.parse(navItemsConfig) 
            : navItemsConfig;
        } catch (e) {
          navItems = [];
        }
        
        // 遍历配置并添加导航项
        if (Array.isArray(navItems) && navItems.length > 0) {
          // 获取当前路由（在每次渲染时都会重新获取）
          let currentRoute = m.route.get();
          
          // 获取基础路径
          const basePath = getBasePath();
          
          // 移除基础路径（如果存在）
          if (basePath && currentRoute.startsWith(basePath)) {
            currentRoute = currentRoute.substring(basePath.length) || '/';
          }
          
          // 如果路径为空或未定义，设置为根路径
          if (!currentRoute || currentRoute === '') {
            currentRoute = '/';
          }
          
          // 确保路径以 / 开头
          if (!currentRoute.startsWith('/')) {
            currentRoute = '/' + currentRoute;
          }
          
          navItems.forEach((navItem, index) => {
            // 检查是否启用（enabled 为 false 时跳过，未定义或 true 时显示）
            if (navItem.enabled === false) {
              return; // 跳过未启用的项
            }
            
            // 检查显示条件
            if (navItem.requireAuth && !app.session.user) {
              return; // 需要登录但用户未登录，跳过
            }
            
            if (navItem.requireGuest && app.session.user) {
              return; // 需要访客但用户已登录，跳过
            }
            
            // 检查用户权限
            if (navItem.requirePermission) {
              if (!app.session.user) {
                return; // 需要权限但用户未登录，跳过
              }
              // 检查权限方法是否存在
              const permissionMethod = 'can' + navItem.requirePermission.charAt(0).toUpperCase() + navItem.requirePermission.slice(1);
              if (typeof app.session.user[permissionMethod] === 'function') {
                if (!app.session.user[permissionMethod]()) {
                  return; // 没有权限，跳过
                }
              } else {
                // 如果方法不存在，尝试从属性中读取
                const hasPermission = app.session.user.attribute(permissionMethod);
                if (!hasPermission) {
                  return; // 没有权限，跳过
                }
              }
            }
            
            // 生成唯一key
            const key = navItem.key || `custom-nav-${index}`;
            const priority = navItem.priority !== undefined ? navItem.priority : (10 + index);
            
            // 根据类型创建不同的导航项
            if (navItem.type === 'link' || !navItem.type) {
              // 链接类型 - 使用文本链接样式
              const originalHref = navItem.href || navItem.url || '#';
              
              // 改进激活状态判断：支持精确匹配和路径前缀匹配
              // 在每次渲染时重新计算，确保路由变化后能正确更新
              let isActive = false;
              
              // 规范化路径（移除末尾的斜杠和查询参数进行比较）
              const normalizePath = (path) => {
                if (!path || path === '#' || path === '') return '';
                
                // 处理以 # 开头的路径（如 #/groups）
                let cleanPath = path;
                if (cleanPath.startsWith('#')) {
                  cleanPath = cleanPath.substring(1); // 移除开头的 #
                }
                
                // 移除查询参数和哈希片段
                cleanPath = cleanPath.split('?')[0].split('#')[0];
                
                // 移除末尾斜杠（除了根路径）
                if (cleanPath === '/' || cleanPath === '') {
                  return cleanPath === '/' ? '/' : '';
                }
                
                return cleanPath.replace(/\/$/, '');
              };
              
              const normalizedHref = normalizePath(originalHref);
              const normalizedRoute = normalizePath(currentRoute);
              
              // 详细的路由匹配逻辑
              if (normalizedHref === '') {
                isActive = false;
              } else if (normalizedHref === normalizedRoute) {
                // 精确匹配
                isActive = true;
              } else if (normalizedHref !== '' && normalizedRoute.startsWith(normalizedHref)) {
                // 检查是否是路径前缀（但要避免误判，如 /about 不应该匹配 /ab）
                const nextChar = normalizedRoute[normalizedHref.length];
                if (!nextChar || nextChar === '/' || nextChar === '?') {
                  isActive = true;
                }
              }
              
              // 如果还没有匹配，尝试匹配当前路径的各个部分
              if (!isActive && normalizedHref !== '') {
                // 检查是否是当前路由的子路径
                const routeParts = normalizedRoute.split('/').filter(p => p);
                const hrefParts = normalizedHref.split('/').filter(p => p);
                
                // 如果href是当前路由的开始部分
                if (hrefParts.length > 0 && routeParts.length >= hrefParts.length) {
                  let allMatch = true;
                  for (let i = 0; i < hrefParts.length; i++) {
                    if (routeParts[i] !== hrefParts[i]) {
                      allMatch = false;
                      break;
                    }
                  }
                  if (allMatch) {
                    isActive = true;
                  }
                }
              }
              
              // 构建类名，确保 is-active 类能正确添加
              const className = 'CustomHeader-nav-link' + (isActive ? ' is-active' : '');
              
              // 使用Flarum的Link组件，它会自动处理SPA路由跳转
              if (navItem.external) {
                // 外部链接使用普通a标签
                items.add(
                  key,
                  m('a', {
                    className: className,
                    href: originalHref,
                    target: navItem.target || '_blank',
                    onclick: (e) => {
                      e.stopPropagation();
                    }
                  }, navItem.text || navItem.label || app.translator.trans('tf-custom-header.forum.header.nav_item')),
                  priority
                );
              } else {
                // 内部链接使用Flarum的Link组件（自动处理SPA路由）
                // Link组件需要包含基础路径的完整路径，因为它会与m.route.get()比较
                const routeHref = normalizeHrefPath(originalHref);
                items.add(
                  key,
                  Link.component({
                    className: className,
                    href: routeHref, // 使用包含基础路径的完整路径
                    onclick: (e) => {
                      e.stopPropagation();
                    }
                  }, navItem.text || navItem.label || app.translator.trans('tf-custom-header.forum.header.nav_item')),
                  priority
                );
              }
            } else if (navItem.type === 'button') {
              // 按钮类型 - 使用LinkButton组件（自动处理SPA路由）
              if (navItem.href || navItem.url) {
                const originalHref = navItem.href || navItem.url;
                if (navItem.external) {
                  // 外部链接使用普通Button
                  items.add(
                    key,
                    Button.component({
                      className: navItem.className || 'Button Button--primary',
                      icon: navItem.icon,
                      onclick: () => {
                        window.open(originalHref, navItem.target || '_blank');
                      }
                    }, navItem.text || navItem.label || app.translator.trans('tf-custom-header.forum.header.nav_item')),
                    priority
                  );
                } else {
                  // 内部链接使用LinkButton组件（自动处理SPA路由）
                  // LinkButton需要包含基础路径的完整路径，因为它会与m.route.get()比较
                  const routeHref = normalizeHrefPath(originalHref);
                  items.add(
                    key,
                    LinkButton.component({
                      className: navItem.className || 'Button Button--primary',
                      icon: navItem.icon,
                      href: routeHref // 使用包含基础路径的完整路径
                    }, navItem.text || navItem.label || app.translator.trans('tf-custom-header.forum.header.nav_item')),
                    priority
                  );
                }
              } else {
                // 没有href的按钮，使用普通Button
                items.add(
                  key,
                  Button.component({
                    className: navItem.className || 'Button Button--primary',
                    icon: navItem.icon
                  }, navItem.text || navItem.label || app.translator.trans('tf-custom-header.forum.header.nav_item')),
                  priority
                );
              }
            }
          });
        }
      }
    } catch (error) {
      // 静默处理错误
    }
  });
  
  // 关闭 App-drawer 的函数
  const closeAppDrawer = () => {
    if (typeof document === 'undefined') return;
    
    // 方法1: 移除 body 上的 drawer-open 类
    document.body.classList.remove('drawer-open');
    
    // 方法2: 移除 App-drawer 上的 is-open 类
    const appDrawer = document.querySelector('.App-drawer, .Navigation-drawer');
    if (appDrawer) {
      appDrawer.classList.remove('is-open');
    }
    
    // 方法3: 触发点击遮罩层来关闭 drawer（如果存在）
    const drawerBackdrop = document.querySelector('.drawer-backdrop, .App-backdrop');
    if (drawerBackdrop) {
      drawerBackdrop.click();
    }
    
    // 方法4: 触发 ESC 键事件（某些 drawer 实现会响应 ESC 键）
    const escEvent = new KeyboardEvent('keydown', {
      key: 'Escape',
      keyCode: 27,
      bubbles: true
    });
    document.dispatchEvent(escEvent);
  };

  // 在 HeaderSecondary 中添加发帖按钮
  // Flarum 的搜索框优先级是 30，优先级越大越靠前，我们使用 40 确保在搜索框之前
  extend(HeaderSecondary.prototype, 'items', function (items) {
    items.add(
      'newDiscussion',
      Button.component({
        className: 'Button Button--primary CustomHeader-newDiscussion',
        icon: null,
        onclick: () => {
          // 关闭 App-drawer（如果打开）
          closeAppDrawer();
          
          // 如果用户未登录，显示登录弹窗
          if (!app.session.user) {
            app.modal.show(LogInModal);
          } else {
            // 打开讨论创建弹窗
            app.composer.load(DiscussionComposer, {});
            app.composer.show();
          }
        }
      }, app.translator.trans('tf-custom-header.forum.header.new_discussion_button')),
      40 // Flarum 搜索框的优先级是 30，优先级越大越靠前，使用 40 确保按钮在搜索框之前
    );
  });

  // ========== 页面历史记录和返回功能（使用浏览器 History API） ==========
  
  // 使用浏览器原生的 History API 来保存和恢复滚动位置
  // 这样可以与浏览器的前进/后退按钮完美配合
  
  // 保存滚动位置到 history.state
  const saveScrollPositionToHistory = () => {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    
    const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || 0;
    const currentState = window.history.state || {};
    
    // 更新当前历史记录的 state，保存滚动位置
    window.history.replaceState({
      ...currentState,
      scrollPosition: scrollPosition,
      route: m.route.get()
    }, '', window.location.href);
  };
  
  // 从 history.state 恢复滚动位置
  const restoreScrollPositionFromHistory = () => {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    
    const state = window.history.state;
    const scrollPosition = state && state.scrollPosition !== undefined ? state.scrollPosition : 0;
    
    // 使用 requestAnimationFrame 确保 DOM 已渲染
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        window.scrollTo({
          top: scrollPosition,
          behavior: 'auto' // 不使用平滑滚动，立即跳转
        });
      });
    });
  };
  
  // 拦截路由变化，使用浏览器 History API 保存和恢复滚动位置
  if (typeof window !== 'undefined') {
    // 禁用浏览器的自动滚动恢复，由我们自己控制
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
    
    // 使用全局标志来标识是否是返回导航
    window.__isNavigatingBack = false;
    // 标识是否正在处理返回操作（防止重复点击）
    window.__isProcessingBack = false;
    // 用于跟踪是否需要重置滚动位置的标志
    let shouldResetScroll = false;
    // MutationObserver 用于监听 DOM 变化
    let scrollResetObserver = null;
    
    // 创建滚动重置函数
    const resetScrollToTop = () => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    };
    
    // 初始化当前页面的 history.state（如果还没有）
    const initHistoryState = () => {
      if (!window.history.state || !window.history.state.route) {
        const currentRoute = m.route.get();
        const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || 0;
        window.history.replaceState({
          route: currentRoute,
          scrollPosition: scrollPosition
        }, '', window.location.href);
      }
    };
    
    // 保存原始 m.route.set 方法
    const originalRouteSet = m.route.set;
    
    // 重写 m.route.set 以拦截路由变化
    m.route.set = function(...args) {
      const targetRoute = args[0];
      const currentRoute = m.route.get();
      
      // 如果不是返回导航，且路由确实发生了变化
      if (!window.__isNavigatingBack && targetRoute !== currentRoute) {
        // 在路由变化前，保存当前页面的滚动位置到 history.state
        saveScrollPositionToHistory();
      }
      
      // 调用原始方法（这会触发 pushState）
      const result = originalRouteSet.apply(this, args);
      
      // 路由变化后，如果不是返回导航，初始化新页面的 history.state
      if (!window.__isNavigatingBack) {
        // 延迟初始化，确保新页面已加载
        setTimeout(() => {
          const newRoute = m.route.get();
          if (newRoute !== currentRoute) {
            // 初始化新页面的 state（滚动位置为 0，因为新页面应该从顶部开始）
            const newState = window.history.state || {};
            window.history.replaceState({
              ...newState,
              route: newRoute,
              scrollPosition: 0
            }, '', window.location.href);
          }
        }, 50);
      }
      
      // 如果不是返回导航，将滚动位置重置到顶部（新页面应该从顶部开始）
      if (!window.__isNavigatingBack) {
        shouldResetScroll = true;
        
        // 立即滚动到顶部（防止页面跳转时保持原位置）
        resetScrollToTop();
        
        // 停止之前的观察者（如果有）
        if (scrollResetObserver) {
          scrollResetObserver.disconnect();
          scrollResetObserver = null;
        }
        
        // 创建 MutationObserver 监听 DOM 变化，确保在内容加载后也滚动到顶部
        const mainContent = document.querySelector('.App-content, .DiscussionPage, .UserPage, main');
        if (mainContent) {
          let changeCount = 0;
          scrollResetObserver = new MutationObserver((mutations) => {
            if (shouldResetScroll) {
              resetScrollToTop();
              // 在几次变化后停止观察（避免无限循环）
              changeCount += mutations.length;
              if (changeCount > 10) {
                shouldResetScroll = false;
                if (scrollResetObserver) {
                  scrollResetObserver.disconnect();
                  scrollResetObserver = null;
                }
              }
            }
          });
          
          scrollResetObserver.observe(mainContent, {
            childList: true,
            subtree: true,
            attributes: false
          });
          
          // 5秒后自动停止观察（防止内存泄漏）
          setTimeout(() => {
            shouldResetScroll = false;
            if (scrollResetObserver) {
              scrollResetObserver.disconnect();
              scrollResetObserver = null;
            }
          }, 5000);
        }
        
        // 使用多个时机确保滚动位置重置（DOM 渲染可能需要时间）
        // 方法1: requestAnimationFrame（快速）
        requestAnimationFrame(() => {
          if (shouldResetScroll) resetScrollToTop();
          requestAnimationFrame(() => {
            if (shouldResetScroll) resetScrollToTop();
          });
        });
        
        // 方法2: 延迟执行（确保 DOM 完全渲染）
        setTimeout(() => {
          if (shouldResetScroll) resetScrollToTop();
        }, 100);
        
        setTimeout(() => {
          if (shouldResetScroll) resetScrollToTop();
        }, 300);
        
        setTimeout(() => {
          if (shouldResetScroll) resetScrollToTop();
        }, 500);
        
        // 最终重置标志（1秒后）
        setTimeout(() => {
          shouldResetScroll = false;
        }, 1000);
      }
      
      // 延迟恢复滚动位置（如果是返回导航）
      // 注意：滚动位置恢复和标志重置在返回按钮的onclick中处理
      // 这里不需要重置标志，因为返回按钮的onclick会处理
      
      return result;
    };
    
    // 监听页面滚动，实时更新当前页面的滚动位置到 history.state
    let scrollTimer;
    window.addEventListener('scroll', () => {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(() => {
        saveScrollPositionToHistory();
      }, 150);
    }, { passive: true });
    
    // 监听 popstate 事件（浏览器前进/后退按钮）
    window.addEventListener('popstate', (event) => {
      // 当用户点击浏览器前进/后退按钮时，恢复滚动位置
      if (event.state && event.state.scrollPosition !== undefined) {
        setTimeout(() => {
          restoreScrollPositionFromHistory();
        }, 100);
      } else {
        // 如果没有 state，滚动到顶部
        setTimeout(() => {
          resetScrollToTop();
        }, 100);
      }
    });
    
    // 页面加载完成后，初始化 history.state
    const initPageHistory = () => {
      initHistoryState();
    };
    
    // 等待 DOM 加载完成
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        setTimeout(initPageHistory, 100);
      });
    } else {
      setTimeout(initPageHistory, 100);
    }
  }

  // 移除Navigation-back除点击事件外的所有事件，并添加返回功能
  // 手机端：菜单按钮和返回按钮同时存在，菜单按钮始终显示
  extend(Navigation.prototype, 'view', function (vnode) {
    // 手机端 App-backControl：当有返回按钮时，同时显示菜单按钮（菜单按钮始终存在）
    if (this.attrs.drawer && this.attrs.className && String(this.attrs.className).includes('App-backControl')) {
      const drawerButton = this.getDrawerButton();
      if (drawerButton) {
        const children = vnode.children;
        const childList = Array.isArray(children) ? children : (children ? [children] : []);
        const hasBack = childList.some((c) => c && c.attrs && String(c.attrs.className || '').includes('Navigation-back'));
        if (hasBack) {
          vnode.children = [...childList, drawerButton];
        }
      }
    }

    // extend会自动调用原始方法并将结果作为vnode参数传入
    // 递归处理节点，移除所有除了onclick之外的事件处理器，并增强返回按钮功能
    const processNode = (node) => {
      if (!node) return node;
      
      // 如果是数组，递归处理每个元素
      if (Array.isArray(node)) {
        return node.map(processNode);
      }
      
      // 如果是对象且有attrs属性
      if (node.attrs && typeof node.attrs === 'object') {
        // 检查是否是返回按钮（Navigation-back）
        const isBackButton = node.attrs.className && 
          (node.attrs.className.includes('Navigation-back') || 
           node.attrs.className.includes('App-backControl'));
        
        if (isBackButton) {
          // 保存原始onclick事件
          const originalOnclick = node.attrs.onclick;
          
          // 创建新的onclick处理函数
          node.attrs.onclick = (e) => {
            // 阻止默认行为
            if (e) {
              e.preventDefault();
              e.stopPropagation();
            }
            
            // 如果正在处理返回操作，忽略本次点击（防止重复点击）
            if (typeof window !== 'undefined' && window.__isProcessingBack) {
              return;
            }
            
            // 设置正在处理返回操作的标志
            if (typeof window !== 'undefined') {
              window.__isProcessingBack = true;
              window.__isNavigatingBack = true;
            }
            
            // 使用浏览器的 history.back() 方法返回上一页
            // 这会触发 popstate 事件，我们在 popstate 事件中恢复滚动位置
            if (window.history.length > 1) {
              // 保存当前页面的滚动位置
              saveScrollPositionToHistory();
              
              // 使用浏览器原生的返回功能
              window.history.back();
              
              // 重置处理标志（延迟重置，确保操作完成）
              setTimeout(() => {
                if (typeof window !== 'undefined') {
                  window.__isProcessingBack = false;
                  window.__isNavigatingBack = false;
                }
              }, 300);
            } else {
              // 如果没有历史记录，使用原始onclick或默认行为
              if (typeof window !== 'undefined') {
                window.__isProcessingBack = false;
                window.__isNavigatingBack = false;
              }
              
              if (originalOnclick) {
                originalOnclick.call(this, e);
              } else {
                // 默认返回首页
                m.route.set('/');
              }
            }
          };
        } else {
          // 非返回按钮，只移除除onclick之外的事件处理器
        const onclick = node.attrs.onclick;
        
        // 移除所有以'on'开头的事件处理器（除了onclick）
        Object.keys(node.attrs).forEach(key => {
          if (key.startsWith('on') && key !== 'onclick') {
            delete node.attrs[key];
          }
        });
        
        // 确保onclick事件保留
        if (onclick) {
          node.attrs.onclick = onclick;
          }
        }
      }
      
      // 递归处理children
      if (node.children) {
        node.children = processNode(node.children);
      }
      
      return node;
    };
    
    return processNode(vnode);
  });

  // ========== 移动端搜索功能 ==========
  
  // 移动端检测函数（屏幕宽度 ≤ 767px）
  const isMobile = () => {
    if (typeof window === 'undefined') return false;
    return window.innerWidth <= 767;
  };

  // 搜索框展开/收起状态
  let searchExpanded = false;

  // 清除搜索状态的全局函数（可在路由变化时调用）
  const clearSearchState = () => {
    if (!searchExpanded) return;
    
    searchExpanded = false;
    const appNavigation = document.querySelector('#app-navigation, .App-navigation');
    const searchContainer = appNavigation?.querySelector('.CustomHeader-mobile-search-container');
    
    if (searchContainer && appNavigation) {
      appNavigation.classList.remove('CustomHeader-search-expanded');
      searchContainer.classList.remove('is-expanded');
      searchContainer.style.width = '0';
    }
  };

  // 切换搜索框展开/收起
  const toggleMobileSearch = () => {
    searchExpanded = !searchExpanded;
    const appNavigation = document.querySelector('#app-navigation, .App-navigation');
    const searchContainer = appNavigation?.querySelector('.CustomHeader-mobile-search-container');
    
    if (searchContainer && appNavigation) {
      if (searchExpanded) {
        appNavigation.classList.add('CustomHeader-search-expanded');
        searchContainer.classList.add('is-expanded');
        // 强制设置宽度以确保展开
        searchContainer.style.width = '100%';
        // 聚焦搜索输入框
        setTimeout(() => {
          const searchInput = searchContainer.querySelector('input[type="search"], .FormControl, input');
          if (searchInput) {
            searchInput.focus();
          }
        }, 150);
      } else {
        clearSearchState();
      }
    }
  };

  // 设置移动端搜索功能
  const setupMobileSearch = () => {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    
    const appNavigation = document.querySelector('#app-navigation, .App-navigation');
    if (!appNavigation) return;
    
    if (!isMobile()) {
      // 桌面端恢复搜索框到原位置
      const searchButton = appNavigation.querySelector('.CustomHeader-mobile-search-button');
      const searchContainer = appNavigation.querySelector('.CustomHeader-mobile-search-container');
      const itemSearch = appNavigation.querySelector('.item-search');
      const mobileLogo = appNavigation.querySelector('.CustomHeader-mobile-logo');
      
      if (searchButton) {
        // 恢复 item-search 到 Header-controls
        const headerControls = document.querySelector('.Header-controls');
        if (itemSearch && headerControls && !headerControls.contains(itemSearch)) {
          headerControls.appendChild(itemSearch);
        }
        searchButton.remove();
      }
      if (searchContainer) {
        searchContainer.remove();
      }
      if (mobileLogo) {
        mobileLogo.remove();
      }
      appNavigation.classList.remove('CustomHeader-search-expanded');
      searchExpanded = false;
      return;
    }

    // 检查是否已经处理过
    if (appNavigation.querySelector('.CustomHeader-mobile-search-button')) {
      return;
    }

    // 创建 logo（在 App-navigation 左侧）
    const logoUrl = app.forum.attribute('logoUrl');
    if (logoUrl && !appNavigation.querySelector('.CustomHeader-mobile-logo')) {
      const logoLink = document.createElement('a');
      logoLink.className = 'CustomHeader-mobile-logo';
      logoLink.href = '/';
      logoLink.onclick = (e) => {
        e.preventDefault();
        m.route.set('/');
      };
      
      const logoImg = document.createElement('img');
      logoImg.src = logoUrl;
      logoImg.alt = app.forum.attribute('title') || 'Forum';
      logoImg.className = 'CustomHeader-mobile-logo-img';
      
      logoLink.appendChild(logoImg);
      
      // 将 logo 添加到 App-navigation 的最前面
      appNavigation.insertBefore(logoLink, appNavigation.firstChild);
    }

    // 查找 item-search
    const itemSearch = document.querySelector('.Header-controls .item-search, .item-search');
    if (!itemSearch) return;

    // 创建搜索图标按钮（在 App-navigation 右侧）
    const searchButton = document.createElement('button');
    searchButton.className = 'Button Button--icon CustomHeader-mobile-search-button';
    searchButton.innerHTML = '<i class="fa-light fa-search"></i>';
    searchButton.type = 'button'; // 确保是按钮类型
    searchButton.setAttribute('aria-label', 'Search');
    
    // 使用 addEventListener 而不是 onclick，确保事件正确绑定
    searchButton.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      toggleMobileSearch();
    }, { passive: false });
    
    // 也处理 touchstart 事件（移动端）
    searchButton.addEventListener('touchstart', (e) => {
      e.preventDefault();
      e.stopPropagation();
      toggleMobileSearch();
    }, { passive: false });
    
    // 将按钮添加到 App-navigation 右侧
    appNavigation.appendChild(searchButton);

    // 创建搜索框容器（在 App-navigation 内从左侧向右展开）
    const searchContainer = document.createElement('div');
    searchContainer.className = 'CustomHeader-mobile-search-container';
    
    // 将 item-search 移动到搜索容器内（先添加）
    searchContainer.appendChild(itemSearch);
    
    // 添加关闭按钮（在 item-search 之后）
    const closeButton = document.createElement('button');
    closeButton.className = 'Button Button--icon CustomHeader-mobile-search-close';
    closeButton.innerHTML = '<i class="fa-light fa-times"></i>';
    closeButton.onclick = (e) => {
      e.stopPropagation();
      clearSearchState();
    };
    
    // 将搜索容器添加到 App-navigation 内
    appNavigation.appendChild(searchContainer);
    searchContainer.appendChild(closeButton);
    
    // 确保容器初始状态是隐藏的
    searchContainer.style.width = '0';

    // 点击搜索结果项时清除搜索状态
    const handleSearchResultClick = (e) => {
      // 检查是否点击了搜索结果项（.Search-results li a 或 .Dropdown-menu li a）
      const searchResultLink = e.target.closest('.Search-results li a, .Dropdown-menu li a');
      if (searchResultLink && searchContainer.contains(searchResultLink)) {
        // 点击了搜索结果，清除搜索状态
        clearSearchState();
      }
    };
    
    // 在搜索容器上使用事件委托监听搜索结果点击
    searchContainer.addEventListener('click', handleSearchResultClick, true);

    // 点击外部区域关闭搜索框
    const handleOutsideClick = (e) => {
      if (searchExpanded && searchContainer) {
        if (!searchContainer.contains(e.target) && !searchButton.contains(e.target)) {
          clearSearchState();
        }
      }
    };
    
    // 使用事件委托，避免重复绑定
    document.addEventListener('click', handleOutsideClick, true);
  };

  // 响应式处理函数
  const handleResponsiveLayout = () => {
    setupMobileSearch();
  };

  // 初始化：在 DOM 加载完成后执行
  if (typeof window !== 'undefined') {
    // 等待 DOM 加载完成
    const initMobileLayout = () => {
      setTimeout(handleResponsiveLayout, 200);
    };
    
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initMobileLayout);
    } else {
      initMobileLayout();
    }

    // 监听窗口大小变化
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(handleResponsiveLayout, 150);
    });

    // 监听 Mithril 路由变化（确保在页面切换后也能正确布局）
    const originalRoute = m.route.set;
    if (originalRoute) {
      m.route.set = function() {
        const result = originalRoute.apply(this, arguments);
        setTimeout(handleResponsiveLayout, 200);
        
        // 路由变化时清除搜索状态
        clearSearchState();
        
        return result;
      };
    }
  }

  // ========== 扩展搜索功能，添加群组搜索 ==========
  
  // 扩展 Search 组件，添加群组搜索源
  extend(Search.prototype, 'sourceItems', function (items) {
    // 检查 groups 扩展是否已加载（通过检查路由是否存在）
    if (app.routes && app.routes.groups) {
      items.add('groups', new GroupsSearchSource(), 20);
    }
  });

  } catch (error) {
    console.error('[CustomHeader] 插件初始化失败:', error);
    // 重新抛出错误以便 Flarum 能够显示错误信息
    throw error;
  }
});



